import { Fragment, ReactElement } from 'react'
import StepperMUI from '@material-ui/core/Stepper'
import StepMUI from '@material-ui/core/Step'
import StepContent from '@material-ui/core/StepContent'
import StepLabel from '@material-ui/core/StepLabel'
import { Container, Grid, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/'
import { useStyles } from './style'

import Hairline from 'src/components/layout/Hairline'
import Button from 'src/components/layout/Button'
import Col from 'src/components/layout/Col'
import Row from 'src/components/layout/Row'
import { boldFont, lg, light, sm } from 'src/theme/variables'
import { StepperProvider, useStepper } from './stepperContext'
import Track from 'src/components/Track'
import StepperHeader from './StepperHeader'
import { useForm } from 'react-final-form'

type StepperProps = {
  children: ReactElement[]
  onFinish?: () => void
  disableNextButton?: boolean
  nextButtonType?: string
  testId?: string
  trackingCategory?: string
}

function StepperComponent(): ReactElement {
  const {
    currentStep,
    setCurrentStep,
    steps,

    onClickPreviousStep,
    onClickNextStep,

    disableNextButton,
    nextButtonType,

    testId,
    trackingCategory,
  } = useStepper()
  const formsUtils = useForm()

  const isFirstStep = currentStep === 0
  // const isStepLabelClickable = currentStep > index
  const currentComponent = steps[currentStep]
  const classes = useStyles()

  const backButtonLabel = isFirstStep ? 'Cancel' : 'Back'
  const customNextButtonLabel = currentComponent.props.nextButtonLabel

  const nextButtonLabel = customNextButtonLabel || 'Next'

  const backButton = (
    <Button onClick={onClickPreviousStep} size="small" className={classes.backButton} type="button">
      {backButtonLabel}
    </Button>
  )

  const nextButton = (
    <Button
      onClick={onClickNextStep}
      color="primary"
      type={nextButtonType || 'button'}
      disabled={
        disableNextButton ||
        currentComponent.props.disableNextButton ||
        Object.keys(formsUtils.getState().errors as Object).length > 0
      }
      size="small"
      className={classes.nextButton}
      variant="contained"
    >
      {nextButtonLabel}
    </Button>
  )

  return (
    <Container maxWidth="xl">
      <Grid container className="mt-5" justifyContent="center">
        <Grid item xs={12} sm={8}>
          <Paper className={classes.root} elevation={1}>
            {currentComponent}
            <Hairline />
            <Row align="center" grow className={classes.controlStyle}>
              <Col center="xs" xs={12}>
                {trackingCategory ? (
                  <>
                    <Track category={trackingCategory} action={backButtonLabel} label={currentStep}>
                      {backButton}
                    </Track>
                    <Track category={trackingCategory} action={nextButtonLabel} label={currentStep}>
                      {nextButton}
                    </Track>
                  </>
                ) : (
                  <>
                    {backButton}
                    {nextButton}
                  </>
                )}
              </Col>
            </Row>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  )
}

export default function Stepper(props: StepperProps): ReactElement {
  return (
    <StepperProvider stepsComponents={props.children} {...props}>
      <Fragment>
        <StepperHeader />
        <StepperComponent />
      </Fragment>
    </StepperProvider>
  )
}

export type StepElementProps = {
  label: string
  children: JSX.Element
  nextButtonLabel?: string
  nextButtonType?: string
  disableNextButton?: boolean
}

export type StepElementType = (props: StepElementProps) => ReactElement

export function StepElement({ children }: StepElementProps): ReactElement {
  return children
}
